<div class="root-body">
    <p-toast position="top-right"></p-toast>

    <!-- Create / Edit budget -->
    <p-sidebar *ngIf="showEditSideBar"
               [(visible)]="showEditSideBar"
               [position]="'right'"
               [baseZIndex]="10000"
               (onHide)="closeSideBar()"
               [style]="{width:'560px'}">
        <ng-template pTemplate="header">
            <div class="sidebar-header-title">{{ budget.Id ? 'Edit Budget' : 'Create Budget' }}</div>
        </ng-template>

        <div class="p-3">
            <div class="sidebar-field-block">
                <div class="sidebar-field__label">Budget Name</div>
                <input type="text" [(ngModel)]="budget.Name" placeholder="Enter Budget Name" pInputText />
            </div>

            <div class="sidebar-field-block">
                <div class="sidebar-field__label">Sponsor</div>
                <p-dropdown placeholder="Select sponsor (optional)"
                            [options]="sponsors"
                            optionLabel="Name"
                            optionValue="Id"
                            [showClear]="true"
                            [(ngModel)]="budget.SponsorId">
                </p-dropdown>
            </div>

            <div class="sidebar-field-block">
                <div class="sidebar-field__label">
                    Initial Amount
                    <span class="sidebar-field__label-info" *ngIf="!budget.Id">(seeds current balance)</span>
                    <span class="sidebar-field__label-info" *ngIf="budget.Id">(managed via Adjust)</span>
                </div>
                <p-inputNumber [(ngModel)]="budget.InitialAmount" mode="decimal"
                               [minFractionDigits]="2" [maxFractionDigits]="2" [min]="0"
                               [disabled]="!!budget.Id"></p-inputNumber>
            </div>

            <div class="sidebar-field-block" *ngIf="budget.Id">
                <div class="sidebar-field__label">Current Balance</div>
                <p-inputNumber [ngModel]="budget.CurrentBalance" mode="decimal"
                               [minFractionDigits]="2" [maxFractionDigits]="2" [disabled]="true"></p-inputNumber>
            </div>

            <div class="sidebar-field-block">
                <div class="sidebar-field__label">Currency</div>
                <input type="text" [(ngModel)]="budget.Currency" placeholder="PHP" pInputText />
            </div>

            <div class="sidebar-field-block flex align-items-center" style="gap: 10px;">
                <p-inputSwitch [(ngModel)]="budget.IsActive"></p-inputSwitch>
                <span>{{ budget.IsActive ? 'Active' : 'Inactive' }}</span>
            </div>
        </div>

        <ng-template pTemplate="footer">
            <div class="flex justify-content-end p-3" style="gap: 12px;">
                <button pButton class="white-btn-filter" label="Cancel" (click)="closeSideBar()"></button>
                <button pButton class="bluedark-btn-filter" label="Save" (click)="save()"></button>
            </div>
        </ng-template>
    </p-sidebar>

    <!-- Top up / adjust balance -->
    <p-sidebar *ngIf="showTopUpSideBar"
               [(visible)]="showTopUpSideBar"
               [position]="'right'"
               [baseZIndex]="10000"
               (onHide)="closeTopUp()"
               [style]="{width:'520px'}">
        <ng-template pTemplate="header">
            <div class="sidebar-header-title">Adjust Balance</div>
        </ng-template>

        <div class="p-3">
            <div class="sidebar-field-block">
                <div class="sidebar-field__label">Budget</div>
                <div>{{ topUp.BudgetName }}</div>
            </div>

            <div class="sidebar-field-block">
                <div class="sidebar-field__label">
                    Amount
                    <span class="sidebar-field__label-info">(use a negative value to deduct)</span>
                </div>
                <p-inputNumber [(ngModel)]="topUp.Amount" mode="decimal"
                               [minFractionDigits]="2" [maxFractionDigits]="2"></p-inputNumber>
            </div>

            <div class="sidebar-field-block">
                <div class="sidebar-field__label">Note (optional)</div>
                <textarea style="resize: none; height: 90px; width: 100%;" [(ngModel)]="topUp.Note"
                          placeholder="Reason for the adjustment" pInputText></textarea>
            </div>
        </div>

        <ng-template pTemplate="footer">
            <div class="flex justify-content-end p-3" style="gap: 12px;">
                <button pButton class="white-btn-filter" label="Cancel" (click)="closeTopUp()"></button>
                <button pButton class="bluedark-btn-filter" label="Apply" (click)="saveTopUp()"></button>
            </div>
        </ng-template>
    </p-sidebar>

    <div class="card">
        <p-table [columns]="cols"
                 [value]="budgets"
                 [lazy]="true"
                 responsiveLayout="scroll" dataKey="Id"
                 (onLazyLoad)="handleLazyLoad($event)"
                 [paginator]="true"
                 [(first)]="first"
                 [rows]="rowsPerPage"
                 [rowsPerPageOptions]="rowsPerPageOptions"
                 [totalRecords]="totalRecords"
                 [loading]="loading"
                 [autoLayout]="true"
                 [styleClass]="'p-datatable-gridlines'"
                 [scrollable]="true"
                 [scrollHeight]="'flex'"
                 [style]="{height: 'calc(80vh)'}">
            <ng-template pTemplate="caption">
                <div class="flex flex-row sp-header">
                    <div class="sp-header__col-left">
                        <div class="sp-header__title">Promo Budgets</div>
                    </div>
                    <div class="flex flex-row sp-header__col-right">
                        <div class="ml-20">
                            <button class="bluedark-btn-filter" pButton label="Create Budget" (click)="openCreate()"></button>
                        </div>
                    </div>
                </div>
            </ng-template>
            <ng-template pTemplate="header">
                <tr>
                    <th *ngFor="let col of cols" [style.width]="col.width">{{ col.header }}</th>
                    <th style="width: 130px;">Status</th>
                    <th style="width: 150px;">Action</th>
                </tr>
                <tr>
                    <th></th>
                    <th>
                        <input type="text" pInputText placeholder="Search name" [(ngModel)]="filter.SearchName"
                               (input)="handleHeaderFilterChange()" />
                    </th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-budget>
                <tr>
                    <td *ngFor="let col of cols">{{ budget[col.field] }}</td>
                    <td>
                        <div class="flex flex-row align-items-center" style="gap: 8px;">
                            <p-inputSwitch [(ngModel)]="budget.IsActive" (onChange)="switchActive(budget)"></p-inputSwitch>
                            <span *ngIf="budget.IsActive">Active</span>
                            <span *ngIf="!budget.IsActive">Inactive</span>
                        </div>
                    </td>
                    <td>
                        <span class="action-icon-svg" style="cursor: pointer; margin-right: 12px;" title="Edit" (click)="openEdit(budget)">
                            <img src="../Content/xpress-app/images/svg/icon_edit.svg" />
                        </span>
                        <button pButton class="white-btn-filter" label="Adjust" (click)="openTopUp(budget)"></button>
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td [attr.colspan]="cols.length + 2" style="text-align: center;">No budgets found.</td>
                </tr>
            </ng-template>
            <ng-template pTemplate="paginatorleft">
                <div *ngIf="budgets && budgets.length > 0" style="padding-left: 10px">
                    Displaying {{ first + 1 }} - {{ first + budgets.length }} of {{ totalRecords }}
                </div>
            </ng-template>
        </p-table>
    </div>
</div>
